// Vue directive to add mentionable behaviour to textareas/inputs
//
// It auto-updates value that is bind to element v-model
//
// Usage:
//   v-mentionable="mentionUsernames"
import Tribute from 'tributejs'
import isEqual from 'lodash/isEqual'
import { InputEvent } from '@app/utils/domHelpers'

const initTribute = (el, binding) => {
  const mentionUsernames = binding.value

  if (mentionUsernames.length > 0) {
    el.tributeInstance = new Tribute({
      values: mentionUsernames.map((user) => ({ key: user, value: user })),
    })
    el.tributeInstance.attach(el)

    // Update state manually as a tribute insertion doesn't trigger on:input on v-model binding
    el.addEventListener('tribute-replaced', (event) => {
      el.value = event.target.value
      el.dispatchEvent(InputEvent())
    })
  }
}

const mentionableDirective = {
  beforeMount: function (el, binding, vnode) {
    initTribute(el, binding, vnode)
  },
  updated: function (el, binding, vnode) {
    if (!el.tributeInstance || !isEqual(binding.value, binding.oldValue)) {
      initTribute(el, binding, vnode)
    }
  },
  unmounted: function (el) {
    el.tributeInstance.detach(el)
  },
}

export default mentionableDirective
